<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.processOption')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/"><i class="fa fa-home"></i></router-link>
                    </li>
                    <!-- <li class="breadcrumb-item"><router-link to="/master/processOption"><span>{{$t('tlt.processOption')}}</span></router-link></li> -->
                    <li class="breadcrumb-item">
                        <router-link to="/master/processOption"><span>{{$t('tlt.processOption')}}</span></router-link>
                    </li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('processOption')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <mes-filter entity="processOption"/>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="processOptionListTabel" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <mmf-table entity="processOption" inline-actions-disabled :singleChoice='true'>
                                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                                    <button
                                            :disabled="slotProps.checkedLength!=1"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="showProcessChart(slotProps.checkedItems)">
                                        <i class="fa fa-tasks" aria-hidden="true"></i>
                                        <span class="text">图示</span>
                                    </button>
                                </div>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
            <b-modal
                    id="showProcessChart"
                    ref="showProcessChart"
                    centered
                    size="lg"
                    ok-only
                    :ok-title="$t('lbl.basic.close')">
                <process-option-chart :selected="selected" :data="processData" :links="processLinks"></process-option-chart>
            </b-modal>
        </section>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import MmfTable from "@/components/MmfTable";
    import MesFilter from '@/components/MesFilter'
    import ProcessOptionChart from './components/ProcessOptionChart'

    // 常量
    const moduleName = "processOption";
    const baseUrl = process.env.VUE_APP_MASTER_API_URL + "master-service/master";

    export default {
        components: {
            MmfTable,
            MesFilter,
            ProcessOptionChart
        },
        methods: {
            ...mapActions(moduleName, ["getChartData"]),
            ...mapActions("base", ["MMFLoadRows", "MMFNew"]),
            showProcessChart(checked) {
                this.$store
                    .dispatch("api/get", {
                        url:
                            baseUrl+'/processOption/findChartDataById/'+checked
                    })
                    .then(response => {
                        console.log(response);
                        this.self.option = response.self;
                        this.self.material = response.selfMaterial;
                        this.child.option = response.child;
                        this.child.material = response.childMaterial;
                        this.parent.option = response.parent;
                        this.parent.material = response.parentMaterial;
                        this.processData = [];
                        this.processLinks = [];
                        //添加前工艺段
                        if (this.parent.option != "") {
                            this.selected["前工艺段"] = true;
                            this.processData.push({name: this.parent.option, symbolSize: 70, category: 0});
                            this.processLinks.push({
                                lineStyle:{
                                    color:'#8968CD'
                                },
                                source: this.self.option,
                                target: this.parent.option,
                                name: '前工艺段',
                            });
                            for (var i = 0; i < this.parent.material.length; i++) {
                                this.processData.push({name: this.parent.material[i].materialName, symbolSize: 50, category: 3});
                                this.processLinks.push({
                                    lineStyle:{
                                        color:'#FF4500'
                                    },
                                    source: this.parent.option,
                                    target: this.parent.material[i].materialName,
                                    name: '物料',
                                })
                            }
                        }
                        //添加当前工艺段
                        if (this.self.option!="") {
                            this.selected["当前工艺段"]=true;
                            this.processData.push({name: this.self.option, symbolSize: 70, category: 1})
                            for (var j = 0; j < this.self.material.length; j++) {
                                this.processData.push({name: this.self.material[j].materialName, symbolSize: 50, category: 3});
                                this.processLinks.push({
                                    lineStyle:{
                                        color:'#FF4500'
                                    },
                                    source: this.self.option,
                                    target: this.self.material[j].materialName,
                                    name: '物料',
                                })
                            }
                        }
                        //添加后工艺段
                        if (this.child.option != "") {
                            this.selected["后工艺段"]=true;
                            this.processData.push({name: this.child.option, symbolSize: 70, category: 2});
                            this.processLinks.push({
                                lineStyle:{
                                    color:'#8968CD'
                                },
                                source: this.child.option,
                                target: this.self.option,
                                name: '后工艺段',
                            });
                            for (var k = 0; k < this.child.material.length; k++) {
                                this.processData.push({name: this.child.material[k].materialName, symbolSize: 50, category: 3});
                                this.processLinks.push({
                                    lineStyle:{
                                        color:'#FF4500'
                                    },
                                    source: this.child.option,
                                    target: this.child.material[k].materialName,
                                    name: '物料',
                                })
                            }
                        }
                        // this.ch=this.getChartData(check);
                        console.log(this.processData);
                        this.$refs.showProcessChart.show();
                    });
            }
        },
        data() {
            return {
                moduleName: moduleName,
                parent: {
                    option: "",
                    material: []
                },
                self: {
                    option: "",
                    material: []
                },
                child: {
                    option: "",
                    material: []
                },
                processData: [],
                processLinks: [],
                selected:{
                    "前工艺段":false,
                    "当前工艺段":false,
                    "后工艺段":false,
                    "物料":true
                },
                checked: null
            };
        },
        mounted() {

        }
    };
</script>
